import { render, staticRenderFns } from "./CustomerGroups.vue?vue&type=template&id=39c28847&scoped=true"
import script from "./CustomerGroups.vue?vue&type=script&lang=js"
export * from "./CustomerGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c28847",
  null
  
)

export default component.exports